module.exports = __webpack_public_path__ + "static/media/title2.e860103b.png";